module.exports = __webpack_public_path__ + "static/00007.697b485b.jpg";